// 類型定義
type GAEventParams = {
  hitType: string
  eventCategory: string
  eventAction: string
  eventLabel?: string
}

declare global {
  interface Window {
    ga: (command: string, ...fields: (string | number | object)[]) => void
  }
}

// 常量
enum WebSiteTypeConst {
  SKYEXCHANGE = 1,
  SKYINPLAY = 6
}

export enum GAPageViewConst {
  LOGIN_PAGE = "LoginPageView",
  MIAN_PAGE = "MainPageView"
}

// eslint-disable-next-line @typescript-eslint/no-unused-vars
function ga(arg0: string, ...params: (string | number | object)[]) {
  throw new Error("Function not implemented.")
}

export function useGoogleAnalytics() {
  const websiteInfoStore = useWebsiteInfoStore()

  const trackingIds = new Map<number, string>([
    [WebSiteTypeConst.SKYEXCHANGE, "UA-102845253-1"]
  ])

  const handleError = (error: unknown) => {
    console.warn("GA Error:", error)
  }

  const sendGAEvent = (params: GAEventParams) => {
    try {
      ga("send", params)
    } catch (error) {
      handleError(error)
    }
  }

  const setup = async () => {
    const trackingId = trackingIds.get(websiteInfoStore.state.webSiteType)
    if (!trackingId) return

    try {
      // @ts-ignore
      await import(`../../../public/plugins/googleAnasytics.js`)
      ga("create", trackingId, "auto")
    } catch (error) {
      handleError(error)
    }
  }

  const trackPageView = (page: GAPageViewConst) => {
    if (!window.ga) return
    try {
      ga("send", "pageview", page)
    } catch (error) {
      handleError(error)
    }
  }

  const trackLogin = () => {
    if (!window.ga) return
    try {
      sendGAEvent({
        hitType: "event",
        eventCategory: "login",
        eventAction: "First Landing Page",
        eventLabel: websiteInfoStore.state.userID
      })
    } catch (error) {
      handleError(error)
    }
  }

  const trackSportSelection = (sportName: string) => {
    if (!window.ga) return
    sendGAEvent({
      hitType: "event",
      eventCategory: "selectSport",
      eventAction: sportName
    })
  }

  const trackAppDownload = async () => {
    // SKYINPLAY只有downloadApp才會送事件給GA
    const isValidWebsite = [
      WebSiteTypeConst.SKYEXCHANGE,
      WebSiteTypeConst.SKYINPLAY
    ].includes(websiteInfoStore.state.webSiteType)

    if (!isValidWebsite) return
    if (!window.ga) await setup()

    try {
      const platform = websiteInfoStore.state.isIOS ? "iOS" : "Android"
      sendGAEvent({
        hitType: "event",
        eventCategory: `downloadApp_${platform}`,
        eventAction: websiteInfoStore.state.webSiteDisplayName
      })
    } catch (error) {
      handleError(error)
    }
  }

  const initialize = async () => {
    if (websiteInfoStore.state.webSiteType === WebSiteTypeConst.SKYEXCHANGE) {
      await setup()
    }
  }

  return {
    trackPageView,
    trackLogin,
    trackSportSelection,
    trackAppDownload,
    initialize
  }
}

export default useGoogleAnalytics
